import Typography from '../Typography'
import { useTranslation } from 'react-i18next'
import { Container, ProtexxaLogo, StyledLink, HiddenOnSmallScreen } from './styles'
import Box from '../Box'

export default function Footer() {
  const { t } = useTranslation()

  const marketingToSRoute = process.env.REACT_APP_MARKETING_TOS || ''

  const marketingPPRoute = process.env.REACT_APP_MARKETING_PP || ''

  return (
    <Container>
      <ProtexxaLogo>
        <Typography
          variant="h4"
          sx={{
            color: 'gray.800',
          }}
        >
          protexxa
        </Typography>
      </ProtexxaLogo>
      <Typography
        variant="body2"
        sx={{
          textAlign: 'center',
          color: 'gray.800',
          fontSize: 'body3.fontSize',
          fontWeight: 'body3.fontWeight',
        }}
      >
        {t('footer.message')}
      </Typography>
      <HiddenOnSmallScreen>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <StyledLink onClick={() => (window.location.href = marketingToSRoute)}>
            {t('auth.terms')}
          </StyledLink>
          <Typography
            variant="body2"
            sx={{
              textAlign: 'center',
              color: 'gray.800',
              fontSize: 'body3.fontSize',
              fontWeight: 'body3.fontWeight',
            }}
          >
            &nbsp;&&nbsp;
          </Typography>
          <StyledLink onClick={() => (window.location.href = marketingPPRoute)}>
            {t('auth.policy')}.
          </StyledLink>
        </Box>
      </HiddenOnSmallScreen>
    </Container>
  )
}
